import { createFileRoute } from "@tanstack/react-router"

import { resolveContent } from "@/lib/content-resolver"
import { RSS_FEED_LINK } from "@/lib/rss-meta"
import { seoMeta } from "@/lib/seo"

import type { BlogSearch } from "./-components/blogHelpers"
import { BlogIndexPage } from "./-components/BlogIndexPage"

const modules = import.meta.glob("./-content/*.{md,mdx}", {
  eager: true,
}) as Record<string, { default: React.ComponentType; frontmatter: Record<string, unknown> }>

const blogPosts = resolveContent(modules)

export const Route = createFileRoute("/_content/blog/")({
  validateSearch: (search: Record<string, unknown>): BlogSearch => ({
    category: typeof search["category"] === "string" ? search["category"] : undefined,
  }),
  head: () =>
    seoMeta({
      title: "Blog",
      description: "News, updates, and stories from the Entire team.",
      url: "https://entire.com/blog",
      image: "https://entire.com/images/og/blog.png",
      extraLinks: [RSS_FEED_LINK],
    }),
  component: BlogListPage,
})

function BlogListPage() {
  const search = Route.useSearch()

  return <BlogIndexPage posts={blogPosts} selectedCategory={search.category} />
}
